import { useEffect } from "react";
import { useLocation, useSearch } from "wouter";
import { parseDeepLinkUrl } from "../../../shared/deepLinks";

/**
 * QR Deep-Link Handler
 * 
 * Handles QR code scans by parsing the URL and redirecting to the appropriate log entry page.
 * URL format: /qr/{wellId}?focusField={fieldName}
 */
export default function QRDeepLink() {
  const [location, navigate] = useLocation();
  const searchString = useSearch();

  useEffect(() => {
    const searchParams = new URLSearchParams(searchString);
    const params = parseDeepLinkUrl(location, searchParams);

    if (!params) {
      // Invalid QR code URL, redirect to home
      navigate("/");
      return;
    }

    // Build the log entry URL with well ID and focus field
    const logUrl = new URL("/logs/new", window.location.origin);
    logUrl.searchParams.set("wellId", params.wellId.toString());
    
    if (params.focusField) {
      logUrl.searchParams.set("focusField", params.focusField);
    }

    // Redirect to log entry page
    navigate(logUrl.pathname + logUrl.search);
  }, [location, searchString, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        <p className="mt-4 text-muted-foreground">Opening log entry...</p>
      </div>
    </div>
  );
}
